<template>
  <div>
    <w-error v-if="model && model != {}" :model="model"></w-error>
    <table :class="tableClass" style="margin-bottom: 2em;" ref="table">
      <thead ref="header">
        <slot name="thead"></slot>
      </thead>
      <slot></slot>
    </table>
    <table v-show="floats" :class="[tableClass, 'floating']" :style="'width:' + headerVw + 'vw'">
      <thead ref="floating_header">
        <slot name="thead"></slot>
      </thead>
    </table>
  </div>
</template>

<script>
import WError from './error.vue';
export default {
  name: 'w-form-table',
  props: {
    css: {
      type: String,
      default: 'table table-bordered table-fixed-header noborderdisabled valigntop'
    },
    model: Object,
    //aby floating header dobrze wyglądał - wszystkie th muszą mieć width
    floatingHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      windowY: 0,
      tableY: 0,
      tableHeight: 0,
      tableWidth: 0,
      headerVw: 0,
      fixedWidth: []
    };
  },
  components: {
    WError
  },
  methods: {
    getCells(elem) {
      let cells = elem.querySelectorAll('th');
      if (cells.length === 0) {
        cells = elem.querySelectorAll('td');
      }
      return cells;
    },
    $scroll() {
      this.windowY = window.scrollY;
      let table = this.$refs.table;
      this.headerHeight = this.$refs.header.childNodes[0].clientHeight; // ref floating_header może zmieniać height
      let reck = table.getBoundingClientRect();
      this.tableY = reck.y;
      this.tableWidth = table.clientWidth;
      this.tableHeight = table.clientHeight;
      this.headerVw = (this.tableWidth / window.innerWidth - 2) * 100;

      const floatingCells = this.getCells(this.$refs.floating_header);
      const headerCells = this.getCells(this.$refs.header);

      for (let i = 0; i < floatingCells.length; i++) {
        let rect = headerCells[i].getBoundingClientRect();
        floatingCells[i].removeAttribute('width');
        let computedStyle = window.getComputedStyle(headerCells[i]);
        let pl = parseFloat(computedStyle.paddingLeft);
        let pr = parseFloat(computedStyle.paddingLeft);
        let br = parseFloat(computedStyle.borderRight);
        let bl = parseFloat(computedStyle.borderLeft);
        floatingCells[i].style.width = `${rect.width - pl - pr - bl}px`;
      }
    }
  },
  created() {
    document.onscroll = () => {
      if (this.floatingHeader) this.$scroll();
    };
    window.addEventListener('resize', this.$scroll.bind(this));
  },
  destroyed() {
    window.removeEventListener('resize', this.$scroll);
  },
  computed: {
    floats() {
      return this.floatingHeader && this.tableY < 0 && this.tableHeight + this.tableY - this.headerHeight * 2 > 0;
    },
    tableClass: {
      get() {
        const arr = [this.css];

        if (this.model) {
          const vv = this.model.$value;
        }

        if (this.model && this.model.$error) {
          arr.push('state-error');
        } else {
          arr.push('state-success');
        }
        return arr;
      }
    }
  }
};
</script>

<style scoped>
table.floating {
  position: fixed !important;
  z-index: 100000;
  top: 0;
}
</style>